module.exports = __webpack_public_path__ + "awaiting-arrival-days.png?ff2cb4de687253aea669e006d96e7a1a";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/awaiting-arrival-days.png
// module id = 479
// module chunks = 0